import styled from 'styled-components';
import {Col} from 'antd';

const Styled = styled.th`
  .resizable-title-handle {
    position: absolute;
    right: -5px;
    bottom: 0;
    z-index: 1;
    width: 10px;
    height: 100%;
    cursor: col-resize;
  }
`;

const StyledCol = styled(Col)`
  position: sticky;
  top: -1px;
  z-index: 3;
  background: white;

  &.pagination-header-style {
    border-bottom: 1px solid rgba(0,0,0,10%);
    opacity: 0.95;
  }

  &.pagination-header-style:hover{
    opacity: 1;
    transition: 0.3s;
  }
`;

export {Styled, StyledCol};
